const embeddedBasePageTemplate = require('../../embedded/embedded-base-page.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('embedded',
            {
                abstract: true,
                url: '/embedded',
                resolve: {
                    modules: [
                        '$ocLazyLoad', function ($ocLazyLoad) {
                            return $ocLazyLoad.load('embedded');
                        },
                    ],
                },
                views: {
                    '@': {
                        template: embeddedBasePageTemplate,
                    },
                },
            })
        // login via agent
        .state('embedded.loginviaagent',
            {
                url: '/loginviaagent?linktoken&uid',
                views: {
                    'embedded-base-content@embedded': {
                        template: '<wow-embedded-login-form></wow-embedded-login-form>',
                    },
                },
            })
        // signup via agent
        .state('embedded.registerviaagent',
            {
                url: '/registerviaagent?linktoken&uid',
                views: {
                    'embedded-base-content@embedded': {
                        template: '<wow-embedded-signup-form></wow-embedded-signup-form>',
                    },
                },
            })
        // signup via agent confirmation
        .state('embedded.registerviaagent.confirmation',
            {
                url: '/confirmation?name&email&mobile&birth&work&abn&company&address&shopperid&redirectToAgentUrl',
                views: {
                    'embedded-base-content@embedded': {
                        template: '<wow-embedded-signup-confirmation></wow-embedded-signup-confirmation>',
                    },
                },
            });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/embedded.js